import React,{useState} from "react";

import { useDispatch } from 'react-redux';
import { useSelector } from "react-redux";
   
// import { useSelector } from "react-redux";

import {Link } from "react-router-dom";

import LoadingCards from "../../components/Loading/LoadingCards";

import loadable from '@loadable/component';
const ArrCards= [1,2,3,4,5,6,];
let lazyLoad =   <LoadingCards cards={ArrCards} type="ExtraSmallCard"/>;
const CardNav = loadable(() => import("../../components/UI/CardNav"), {
    fallback: lazyLoad  });
    const CardNavTwo = loadable(() => import("../../components/UI/CardNavTwo"), {
      fallback: lazyLoad  });
      const CardNavTwoTop = loadable(() => import("../../components/UI/CardNavTwoTop"), {
        fallback: lazyLoad  });
      
const CRMnavber=({baseUrl})=>{

    const dispatch = useDispatch();
    
    const handleMouseEnter = () =>dispatch({
      type: "CURSOR",
      
      payload:true
    });
    const handleMouseLeave = () => dispatch({
      type: "CURSOR",
      
      payload:false
    });
 const [statusLoading , setStatusLoading] = useState({status:true});
    const localToken= localStorage.getItem("profile")
    const token = useSelector((state)=>state?.user?.user?.token);
  
    const mainMenuStatus = useSelector((state)=>state?.app?.mainMenuStatus);
setTimeout(()=>{setStatusLoading({status:false})},1000)
     const userdata = useSelector((state)=>state?.user?.user);
    return (<>

   

<div style={{display:"grid",gridTemplateColumns:"100%"}}>
{statusLoading.status?<LoadingCards cards={ArrCards} type="ExtraSmallCard" />:(token===localToken&&token&&localToken)?<>
    {/* <Link   to="/dashboard/profile">
    <CardNav  icon={profileIcon} alt="User" title={userdata?.first_name?("Hey "+userdata?.first_name+" !!! "):"Hey User !!!"}  >
</CardNav>
</Link>  */}


{mainMenuStatus?<div >
<CardNavTwoTop  icon={0} alt="ShowMenu" title=""  >

</CardNavTwoTop>
  </div>:<div >
<CardNavTwoTop  icon={7} alt="Hide Menu" title="Hide Menu"  >

</CardNavTwoTop>
  </div>}

   

<CardNavTwo  icon={1} link={`${baseUrl}/new-lead`} alt="" title="+New Lead"  >

</CardNavTwo>
 
<CardNavTwo  icon={6} alt="" link={`${baseUrl}/dashboard`} title="Dashboard"  >

</CardNavTwo>

<CardNavTwo  icon={2} alt="" link={`${baseUrl}/search`} title="Find A Lead "  >

</CardNavTwo>



{/* 
<Logout/> */}
</>:<> 

</>}

</div>

</>)
}
export default CRMnavber;